import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ViewTableComponent } from '../../base/view-table/view-table.component';

@Component({
  selector: 'app-enrollment-lesson-list-view',
  templateUrl: './enrollment-lesson-list-view.component.html',
  styleUrls: ['./enrollment-lesson-list-view.component.css']
})
export class EnrollmentLessonListViewComponent extends ViewTableComponent implements OnInit {

  @Input() override enrollmentID;
  @Output() dataCountEvent = new EventEmitter<string>();

  /** Statuses that charge the lesson to the enrollment. */
  readonly chargedStatuses = ['Showed', 'No Showed, Charged', 'Canceled Too Late'];

  /**
   * Charged lessons stay until they are unposted, and a group class is never
   * deleted from an enrollment list: the dialog behind the button removes the
   * whole class, for every attendee. Take one student off a class from the
   * group lesson dialog instead.
   */
  canDeleteLesson(element: any): boolean {
    return !this.chargedStatuses.includes(element?.field_status)
      && element?.type !== 'Group Lesson';
  }

  override displayedColumns: string[] = [
    'counter',
    'field_date_and_time',
    'field_date_and_time_1',
    // 'title',
    'field_type',
    'field_instructor',
    'field_status',
    'id',
  ];

  override getData(params: { parameter: string; value: string; }[]) {
    // Show Progress Bar (Loading indicator)
    this.ShowProgressBar = true;

    let body = [
      {
        parameter: 'field_enrollment_target_id',
        value: this.enrollmentID
      }
    ]

    // Load the new data with the filtering parameters.
    this._drupalRESTService.httpGET('/api/v2/enrollment-lessons', body)
      .subscribe((data) => {
        // ShowProgressBar
        this.ShowProgressBar = false;

        this.data = data['results'];
        this.dataSource = new MatTableDataSource(data['results']);

        let showedCounter = data['results'].filter(item => this.chargedStatuses.includes(item.field_status)).length;

        this.data = data['results'].map((item, index) => {
          if (this.chargedStatuses.includes(item.field_status)) {
            item.counter = showedCounter.toString();
            showedCounter--;
          }
          return item;
        });

        // Pagination
        if (data['results'] && this.paginator) {
          // this.paginator.length = data['count'];
          // this.paginator.pageSize = this.pageSize;
          // this.paginator.pageIndex = this.paginationIndex;
        }

        // Emit count to parent component.
        this.dataCountEvent.emit(data['results'].length.toString())
      },
        error => this.handleError(error)
      )
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }
    // DO NOT call updateRouterParams here - prevents duplicate requests
  }
}
